// extracted by mini-css-extract-plugin
export default {"publicHeader":"publicHeader_publicHeader__Z6+rj","publicHeader__logo":"publicHeader_publicHeader__logo__cBPxs"};